export enum Operation {
    NULL = 'NULL',
    AVG = 'AVG',
    MIN = 'MIN',
    MAX = 'MAX',
    SUM = 'SUM',
    LAST = 'LAST',
}
